import { useEffect, useRef } from "react";

export const Visualizer = ({ active = true, bars = 48, className = "", color = "#00F5D4", hot = "#FF2E63", testid = "audio-visualizer" }) => {
  const ref = useRef(null);
  const act = useRef(active);
  act.current = active;

  useEffect(() => {
    const c = ref.current;
    if (!c) return;
    const ctx = c.getContext("2d");
    let raf;
    const vals = new Array(bars).fill(0.1);
    const draw = (ts) => {
      const w = (c.width = c.clientWidth * 2);
      const h = (c.height = c.clientHeight * 2);
      ctx.clearRect(0, 0, w, h);
      const bw = w / bars;
      for (let i = 0; i < bars; i++) {
        const base = act.current
          ? 0.25 + 0.45 * Math.abs(Math.sin(ts / 380 + i * 0.5)) * Math.abs(Math.cos(ts / 900 + i * 0.13)) + Math.random() * 0.3
          : 0.06 + 0.05 * Math.abs(Math.sin(ts / 1200 + i * 0.3));
        vals[i] += (Math.min(1, base) - vals[i]) * 0.18;
        const bh = vals[i] * h;
        const g = ctx.createLinearGradient(0, h, 0, h - bh);
        g.addColorStop(0, color);
        g.addColorStop(1, vals[i] > 0.7 ? hot : color);
        ctx.fillStyle = g;
        ctx.globalAlpha = 0.9;
        ctx.fillRect(i * bw + bw * 0.18, h - bh, bw * 0.64, bh);
      }
      raf = requestAnimationFrame(draw);
    };
    raf = requestAnimationFrame(draw);
    return () => cancelAnimationFrame(raf);
  }, [bars, color, hot]);

  return <canvas ref={ref} data-testid={testid} className={`block w-full ${className}`} />;
};
